import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pick } from 'lodash';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import Joi from 'joi';
import Fa from 'react-fontawesome';
import { Field, reduxForm, SubmissionError } from 'redux-form';
// Import Actions
import { fetchAppUser, updateAppUser } from '../../AdminActions';
import ProgressBar from '../../../../components/progress-bar';
import PermissionTable from '../../../../components/check-user-sync-permissions/permission-table';

class AzureAppUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      error: null,
      valid: false,
      permissions: null,
      showPermissionModal: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.close = this.close.bind(this);
    this.showPermissionModal = this.showPermissionModal.bind(this);
    this.hidePermissionModal = this.hidePermissionModal.bind(this);
    this.loadData();
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadData() {
    this.props.dispatch(fetchAppUser(this.props.organization._id))
      .then(
        (data) => {
          this.initState(data);
        },
        (e) => {
          const data = e.data || e;
          this.setState({ error: data });
        },
      );
  }

  initState(data) {
    this.props.initialize(data);
    this.setState({ hasSetup: data.has_setup, valid: data.valid, loaded: true, permissions: null, showPermissionModal: false });
  }

  close() {
    this.props.onModalClose();
    this.setState({ error: null, hasSetup: false, valid: false, showPermissionModal: false }, () => {
      this.setState({ permissions: null });
    });
  }

  hidePermissionModal() {
    this.setState({ showPermissionModal: false });
  }

  showPermissionModal() {
    this.setState({ showPermissionModal: true });
  }

  handleSubmit(data) {
    const { organization } = this.props;
    const params = pick(data, ['tenant_id', 'resource_url']);
    this.setState({ permissions: null });
    return this.props.dispatch(updateAppUser(organization._id, params))
      .then(
        (updatedOrganization) => {
          this.props.onUpdate(updatedOrganization);
          this.initState(updatedOrganization);
          if (this.props.modal) {
            this.close();
          }
          const el = (<div>Application User added!</div>);
          this.context.addNotification(el, { type: 'success', autoClose: false });
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
          } else if (e.permissions) {
            e._error = 'The application user does not have sufficient permissions';
            this.setState({ permissions: e.permissions });
          }
          throw new SubmissionError(e);
        },
      );
  }

  renderField({
    input, label, type, meta: { touched, error }, componentClass, placeholder,
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        {label !== null && label !== undefined && label.length > 0 && <ControlLabel>{label}:</ControlLabel>}
        <FormControl {...input} componentClass={componentClass} placeholder={(placeholder || label)} type={type} disabled={submitting} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error.join('. ')}</HelpBlock>}
      </FormGroup>
    );
  }

  renderPermissionErrors() {
    const { permissions, showPermissionModal } = this.state;
    if (permissions === null) {
      return null;
    }
    return [
      (
        <Button key="btn" bsSize="sm" onClick={this.showPermissionModal} bsStyle="default">show details</Button>
      ),
      (
        <Modal key="modal" show={showPermissionModal} onHide={this.hidePermissionModal}>
          <Modal.Header closeButton>
            <Modal.Title>Permission Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PermissionTable
              permissions={permissions.permissions}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hidePermissionModal} bsStyle="default">Close</Button>
          </Modal.Footer>
        </Modal>
      )
    ];
  }

  renderBody() {
    const {
      handleSubmit, submitting, modal, error,
    } = this.props;
    const { hasSetup, valid } = this.state;
    const formValid = this.props.valid;

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Modal.Body>
          {hasSetup && !valid &&
            <div className="alert alert-danger">The current app user is not valid.</div>
          }
          {error !== null &&
            <div className="alert alert-danger">
              {error} {this.renderPermissionErrors()}
            </div>
          }
          <Field name="tenant_id" type="text" component={this.renderField} label="Tenant ID" />
          <Field name="resource_url" type="text" component={this.renderField} label="Resource URL" />
        </Modal.Body>
        <Modal.Footer className="clearfix">
          {modal && <Button className="pull-left" bsStyle="link" disabled={submitting} onClick={this.close}>Cancel</Button>}

          {!hasSetup && <Button className="pull-right" bsStyle="primary" disabled={(!formValid || submitting)} type="submit">
            {!submitting && <span><Fa name="plus" /> Add</span>}
            {submitting && <span><Fa name="spinner" spin /> Adding</span>}
          </Button>}
          {hasSetup && <Button className="pull-right" bsStyle="primary" disabled={(!formValid || submitting)} type="submit">
            {!submitting && <span><Fa name="pencil" /> Update</span>}
            {submitting && <span><Fa name="spinner" spin /> Updating</span>}
          </Button>}
        </Modal.Footer>
      </form>
    )
  }

  render() {
    const { organization, modal } = this.props;
    const { loaded, error  } = this.state;

    let body = (
      <Modal.Body>
        <ProgressBar />
        <p />
      </Modal.Body>
    );
    if (error) {
      body = (
        <Modal.Body>
          <div className="alert alert-danger">{error}</div>
        </Modal.Body>
      );
    }
    if (loaded) {
      body = this.renderBody();
    }
    const title = `Manage Application User for ${organization.display_name}`;

    if (!modal) {
      return (
        <div className="panel panel-default">
          <div className="panel-heading">
            <div className="panel-title">{title}</div>
          </div>
          <div className="panel-body">
            {body}
          </div>
        </div>
      )
    }

    return (
      <Modal show={this.props.show} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        {body}
      </Modal>
    );
  }

}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

AzureAppUser.propTypes = {
  initialize: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  onUpdate: PropTypes.func,
  organization: PropTypes.shape({
    _id: PropTypes.string,
    display_name: PropTypes.string,
  }).isRequired,
  show: PropTypes.bool,
  modal: PropTypes.bool,
  onModalClose: PropTypes.func,
  error: PropTypes.string,
  valid: PropTypes.bool,
};
AzureAppUser.defaultProps = {
  onUpdate: () => {},
  show: false,
  modal: true,
  onModalClose: () => {},
  error: null,
  valid: false,
};
AzureAppUser.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

const validate = (values) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   resource_url: {
  //     type: 'string',
  //     presence: { allowEmpty: false },
  //     url: true,
  //   },
  //   tenant_id: {
  //     type: 'string',
  //     presence: { allowEmpty: false },
  //   },
  // };

  const schema = Joi.object({
    resource_url: Joi.string().uri().required().messages({
      'string.base': 'Resource URL must be a string',
      'string.empty': 'Resource URL is required',
      'any.required': 'Resource URL is required',
      'string.uri': 'Resource URL must be a valid URL',
    }),
    tenant_id: Joi.string().required().messages({
      'string.base': 'Tenant ID must be a string',
      'string.empty': 'Tenant ID is required',
      'any.required': 'Tenant ID is required',
    }),
  }).unknown(true);

  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const AzureAppUserForm = reduxForm({
  form: 'azureAppUserForm',
  validate,
})(AzureAppUser);

export default connect(mapStateToProps)(AzureAppUserForm);
